import React from 'react';
import { ProductMessage as ProductMessageType, MessageType } from '../../PdpProductProvider/types';
import { ProductMessage } from './ProductMessage/ProductMessage';
import { styles } from './ProductMessages.css';

export type ProductMessagesProps = {
  messages: Array<ProductMessageType>;
  allowedTypes: Array<MessageType>;
  allowedImages?: boolean;
};

export const ProductMessages = ({ messages, allowedTypes, allowedImages = true }: ProductMessagesProps) => {
  const filteredMessages = messages?.filter(message => allowedTypes.includes(message.type));
  return filteredMessages ? (
    <div className={styles.container}>
      {filteredMessages.map(message => (
        <ProductMessage key={`${message.id}-product-message`} message={message} isAllowedImage={allowedImages} />
      ))}
    </div>
  ) : null;
};
